const parseVisibilityConditions = (value, formItems, formItemConditions) => {
    let flattenedItems = flattenItems(formItems);
    let visibilityConditions = {};
    walkValue(value, (value, formItemId) => {
        if(formItemConditions[formItemId]){
            if (_.isArrayLikeObject(value)) {
                _.each(formItemConditions[formItemId], itemCondition => {
                    let itemConditionValues = _.get(itemCondition, 'value', null);
                    let processFormItem = _.find(flattenedItems, ['ProcessFormItem.id', formItemId]);
                    let match;
                    if(_.isNil(visibilityConditions[itemCondition.action_process_form_item_id])){
                        visibilityConditions[itemCondition.action_process_form_item_id] = [];
                    }
                    let fieldTypeAlias = _.get(processFormItem, 'FieldType.alias', null);
                    if(_.includes(['Boolean', 'Checkbox'], fieldTypeAlias)){
                        itemConditionValues = _.map(itemConditionValues, value => value === '1');
                        match = value.some((val) => itemConditionValues.indexOf(val) !== -1);
                    }else {
                        if (_.includes(itemConditionValues, '-2')) {
                            match = value.some(val => val > 0);
                        } else if (_.includes(itemConditionValues, '-1')) {
                            match = !_.size(_.filter(value, v => !_.isNil(v)));
                        } else {
                            match = value.some((val) => itemConditionValues.indexOf(val) !== -1);
                        }
                    }
                    visibilityConditions[itemCondition.action_process_form_item_id].push(itemCondition.action === 'show' ? match : !match);
                });
            }
        }
    });
    return visibilityConditions;
};

const getValueFromURL = (paramName, isMulti = false) => {
    if(!paramName) {
        return isMulti ? [] : null;
    }
    let url = new URL(window.location);
    let paramValue = url.searchParams.get(paramName);
    if(isMulti) {
        return paramValue ? paramValue.split(',') : [];
    }
    return paramValue || null;
};

let defaultValues = {};
const valueTree = (value, formItems, autofillFromUrl = false) => {
    _.each(formItems, (formItem, i) => {
        // Recursively call this function for the next elements if we are in a Wrapper
        if (formItem.ProcessFormItem.item_type === 'wrapper') {
            valueTree(value, formItem.children, autofillFromUrl);
            return;
        }

        // Build default values
        if(formItem.ProcessFormItem.is_fieldset && formItem.ProcessFormItem.item_type === 'address'){
            _.set(defaultValues, `defaultCountry`, _.get(formItem, 'ProcessFormItem.settings.default_country', null));
        }
        if(formItem.ProcessFormItem.is_fieldset && formItem.ProcessFormItem.item_type === 'secondary_email'){
            _.set(defaultValues, `${formItem.ProcessFormItem.id}.emailTypeId`, _.get(formItem, 'ProcessFormItem.settings.default_email_type', null));
        }
        if(formItem.ProcessFormItem.is_fieldset && formItem.ProcessFormItem.item_type === 'phone'){
            _.set(defaultValues, `${formItem.ProcessFormItem.id}.defaultPhone`, _.get(formItem, 'ProcessFormItem.settings.mark_as_default_phone') === 1);
            _.set(defaultValues, `${formItem.ProcessFormItem.id}.phoneTypeId`, _.get(formItem, 'ProcessFormItem.settings.default_phone_type', null));
        }
        if(formItem.ProcessFormItem.is_fieldset && formItem.ProcessFormItem.item_type === 'instant_messenger'){
            _.set(defaultValues, `${formItem.ProcessFormItem.id}.instantMessengerTypeId`, _.get(formItem, 'ProcessFormItem.settings.default_instant_messenger_type', null));
        }
        if(formItem.ProcessFormItem.is_fieldset && formItem.ProcessFormItem.item_type === 'social_network'){
            _.set(defaultValues, `${formItem.ProcessFormItem.id}.socialNetworkTypeId`, _.get(formItem, 'ProcessFormItem.settings.default_social_network_type', null));
        }

        // Add values for person fields
        if (formItem.ProcessFormItem.person_field) {
            // Set field values to null or values taken from URL params
            if (!value[formItem.ProcessFormItem.id] && !_.isBoolean(value[formItem.ProcessFormItem.id])) {
                value[formItem.ProcessFormItem.id] = getValueFromURL(formItem.ProcessFormItem.url_autocomplete_param);
            }
            // Set field values to default values if we don't have a value yet
            if(!value[formItem.ProcessFormItem.id] && formItem.ProcessFormItem.person_field === 'location_country_id'){
                value[formItem.ProcessFormItem.id] = _.get(defaultValues, `defaultCountry`, false);
            }
            if(_.isNull(value[formItem.ProcessFormItem.id]) && formItem.ProcessFormItem.person_field === 'email_type_id'){
                value[formItem.ProcessFormItem.id] = _.get(defaultValues, `${formItem.ProcessFormItem.parent_id}.emailTypeId`, null);
            }
            if(_.isNull(value[formItem.ProcessFormItem.id]) && formItem.ProcessFormItem.person_field === 'default'){
                value[formItem.ProcessFormItem.id] = _.get(defaultValues, `${formItem.ProcessFormItem.parent_id}.defaultPhone`, false);
            }
            if(_.isNull(value[formItem.ProcessFormItem.id]) && formItem.ProcessFormItem.person_field === 'phone_type_id'){
                value[formItem.ProcessFormItem.id] = _.get(defaultValues, `${formItem.ProcessFormItem.parent_id}.phoneTypeId`, null);
            }
            if(_.isNull(value[formItem.ProcessFormItem.id]) && formItem.ProcessFormItem.person_field === 'instant_messenger_type_id'){
                value[formItem.ProcessFormItem.id] = _.get(defaultValues, `${formItem.ProcessFormItem.parent_id}.instantMessengerTypeId`, null);
            }
            if(_.isNull(value[formItem.ProcessFormItem.id]) && formItem.ProcessFormItem.person_field === 'social_media_type_id'){
                value[formItem.ProcessFormItem.id] = _.get(defaultValues, `${formItem.ProcessFormItem.parent_id}.socialNetworkTypeId`, null);
            }
            return;
        }

        // Add empty array for each field that is not a person field
        if (!value[formItem.ProcessFormItem.id]) {
            value[formItem.ProcessFormItem.id] = [];
        }

        // Set field values to null or values taken from URL params
        if(formItem.ProcessFormItem.is_multi && (formItem.ProcessFormItem.namespace === 'multiselect' || formItem.ProcessFormItem.namespace === 'checkboxgroup')) {
            let valueFromURL = getValueFromURL(formItem.ProcessFormItem.url_autocomplete_param, true);
            if(autofillFromUrl && valueFromURL.length) value[formItem.ProcessFormItem.id] = valueFromURL;
        }else {
            let valueFromUrl = getValueFromURL(formItem.ProcessFormItem.url_autocomplete_param, true);
            let numberOfItems = formItem.ProcessFormItem.multi_min || 1;
            if(autofillFromUrl && valueFromUrl && valueFromUrl.length > numberOfItems) numberOfItems = valueFromUrl.length;
            for (let j = 0; j < numberOfItems; j++) {
                if (typeof value[formItem.ProcessFormItem.id][j] == 'undefined') {
                    value[formItem.ProcessFormItem.id][j] = formItem.ProcessFormItem.is_fieldset ? {} : valueFromUrl[j] || null;
                }
            }
        }

        // Add id to crm fieldsets
        if (formItem.ProcessFormItem.is_fieldset && ['person', 'entity', 'secondary_email', 'address', 'phone', 'instant_messenger', 'social_network'].includes(formItem.ProcessFormItem.item_type)) {
            _.each(value[formItem.ProcessFormItem.id], (vv) => {
                if (!vv.id) {
                    vv.id = null;
                }
            });
        }

        // Recursively call this function for the next elements if we are in a Fieldset
        if (formItem.ProcessFormItem.is_fieldset && formItem.children) {
            _.each(value[formItem.ProcessFormItem.id], (vv) => {
                valueTree(vv, formItem.children, autofillFromUrl);
            });
        }
    });
};

const walkValue = (value, callback) => {
    //todo: this will fail if we have objects who's keys are not form item ids
    if (_.isArrayLikeObject(value)) {
        _.each(value, (v) => {
            walkValue(v, callback);
        })
    } else if (_.isObject(value)) {
        _.each(value, (v, i) => {
            callback(v, i);
            walkValue(v, callback);
        });
    }
};

const walkItems = (items, callback) => {
    _.each(items, (item) => {
        callback(item);
        if (item.children) {
            walkItems(item.children, callback)
        }
    });
};

const flattenItems = items => {
    let flattenedItems = [];
    walkItems(items, (formItem) => {
        flattenedItems.push(formItem);
    });
    return flattenedItems;
};

const convertFormValue = (value, formItems, autoFillFromUrl = false) => {
    let newValue = _.clone(value);
    valueTree(newValue, formItems, autoFillFromUrl);
    return newValue;
};

const parseItemKeys = (value, count = false) => {
    let itemKeys = [];
    if(_.size(value)) {
        _.each(value, (val, index) => itemKeys.push(index));
    }else{
        itemKeys.push(0);
    }

    if(count){
        return _.size(itemKeys);
    }
    return itemKeys;
};

const parseChanges = (changes, vars, previousVars, pathPrefix = null) => {
    _.each(vars, (value, key) => {
        let path = `${pathPrefix ? `${pathPrefix}|` : ''}${key}`;
        if (_.isPlainObject(value) && !_.includes(key, '@')) {
            parseChanges(changes, value, previousVars, path);
        } else if (_.isArray(value) && !_.includes(key, '@')) {
            parseChanges(changes, value, previousVars, path);
        } else {
            let previousPath = _.replace(path, /\|/g, '.');
            let previousValue = _.get(previousVars, previousPath);
            if (previousValue !== value) {
                _.set(changes, path, {from: previousValue, to: value});
            }
        }
    });
}

const useRenderDebug = (identifier, vars, ref = null) => {
    if(!SS.vars.debug){
        return;
    }
    const previousVars = React.useRef();
    React.useEffect(() => {
        const [component, name] = _.split(identifier, '|');
        if (previousVars.current) {
            let changes = {};
            parseChanges(changes, vars, previousVars.current);
            changes = Object.keys(changes).reduce((value, path) => ({...value, ...{[_.replace(path, /\|/g, '.')]: changes[path]}}), {});

            console.groupCollapsed(`%cComponent: "${component}"${name ? ` identified by "${name}"` : ''} rendered`, 'color: #039be5');
            if (ref) console.log(ref.current);
            if (Object.keys(changes).length) {
                console.table(changes);
            } else {
                console.log('%cUntracked variable changed', 'color: orange');
            }
            console.groupEnd();
        }
        previousVars.current = vars;
    });
}